export default __webpack_public_path__ + "static/media/machines.51d64c8c.JPG";